import { render, staticRenderFns } from "./AdSlots.vue?vue&type=template&id=1f4c87a1&"
import script from "./AdSlots.vue?vue&type=script&lang=js&"
export * from "./AdSlots.vue?vue&type=script&lang=js&"
import style0 from "./AdSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports